import { render, staticRenderFns } from "./ServicePointModal.vue?vue&type=template&id=ddb906b2&scoped=true&"
import script from "./ServicePointModal.vue?vue&type=script&lang=ts&"
export * from "./ServicePointModal.vue?vue&type=script&lang=ts&"
import style0 from "./ServicePointModal.vue?vue&type=style&index=0&id=ddb906b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb906b2",
  null
  
)

export default component.exports